/** Every load gets a predicate that becomes false after a newer load, save, or scope change. */
export function createRequestGate() {
  let revision = 0;
  return {
    begin() {
      const started = ++revision;
      return () => started === revision;
    },
    invalidate() {
      revision++;
    },
  };
}

/** Synchronous acquisition also blocks a second click before React renders the disabled button. */
export function createActionLock() {
  let locked = false;
  return {
    acquire() {
      if (locked) return false;
      locked = true;
      return true;
    },
    release() {
      locked = false;
    },
  };
}
